export default {
  brand: 'AllChinaBuy Spreadsheet',
  nav: {
    home: 'Hjem',
    categories: 'Kategorier',
    guide: 'Spreadsheet-guide',
    guides: 'Guides',
    about: 'Om os',
    sheet: 'AllChinaBuy Sheet',
    faq: 'FAQ',
    collapse: 'Skjul',
    expand: 'Vis',
  },
  lang: {
    label: 'Sprog',
    en: 'English',
    fr: 'Français',
    da: 'Dansk',
    de: 'Deutsch',
  },
  cta: {
    spreadsheet: 'AllChinaBuy Spreadsheet',
    buyNow: 'Køb nu',
    explore: 'Udforsk spreadsheetet',
    browse: 'Gennemse kategorier',
    readGuide: 'Læs guiden',
    backHome: 'Tilbage til forsiden',
    allCategories: 'Alle kategorier',
  },
  disclosure:
    'Dette website er en uafhængig informationsressource og er ikke tilknyttet eller godkendt af AllChinaBuy. Vi kan modtage provision fra kvalificerende køb foretaget via links på dette website.',
  footer: {
    tagline:
      'Din uafhængige guide til at finde produkter, tjekke kvaliteten og handle smartere med AllChinaBuy-spreadsheetet.',
    quickLinks: 'Genveje',
    categoriesTitle: 'Kategorier',
    resources: 'Ressourcer',
    guide: 'Spreadsheet-guide',
    safety: 'Sikkerhed & Ansvarsfraskrivelse',
    copyright: '© 2026 AllChinaBuy Spreadsheet. Alle rettigheder forbeholdes.',
    madeWith: 'Lavet til smartere shopping.',
  },
};